export const navItems = [
  { label: "Home", path: "/" },
  { label: "Shop", path: "/shop" },
  { label: "Tote Bags", path: "/category/tote-bags" },
  { label: "Artisans", path: "/meet-the-artisans" },
  { label: "Sustainability", path: "/sustainability" },
  { label: "Impact", path: "/impact" },
  { label: "Gifting", path: "/corporate-gifting" },
  { label: "Founder’s Note", path: "/founders-note" },
  { label: "Collaborate", path: "/collaborate" },
  { label: "Contact", path: "/contact" },
];

export const categoryRoutes = {
  "tote-bags": "Tote Bags",
  pouches: "Pouches",
  "coin-holders": "Coin Holders",
  "pencil-boxes": "Pencil Boxes",
};

export const artisanStories = [
  {
    name: "The Women of Kutch",
    skill: "Textile artisans and cultural makers",
    contribution: "Hand-finishing, textile sensibility and product detailing",
    story:
      "A collective of skilled women artisans creating handcrafted textile products with patience, cultural memory and dignity.",
    access:
      "Project Umeed helps their work reach modern buyers, gifting clients and digital audiences beyond local markets.",
  },
  {
    name: "Meera",
    skill: "Textile Artisan, Kutch",
    contribution: "Colour composition and tote finishing",
    story:
      "Meera brings traditional colour sensibility into every piece she creates, shaping everyday products with quiet confidence.",
    access:
      "Through Project Umeed, her craft can be positioned for buyers who value handmade quality and ethical lifestyle design.",
  },
  {
    name: "Asha",
    skill: "Stitching and product assembly",
    contribution: "Pouches, pencil boxes and finishing details",
    story:
      "Asha transforms fabric into useful objects that feel personal, durable and beautifully made.",
    access:
      "Umeed supports her with design direction, sales visibility, packaging, pricing guidance and customer access.",
  },
];

export const whyBuyPoints = [
  "Handmade by women artisans from Kutch",
  "Supports long-term livelihood creation",
  "Designed as premium ethical lifestyle products",
  "Locally sourced materials wherever possible",
  "Plastic-free packaging approach",
  "Eco-dyed and conscious production wherever applicable",
  "Longer-lasting handmade products",
  "Direct digital visibility for artisans",
  "Ideal for personal use and gifting",
  "Every purchase supports women’s access to wider markets",
];

export const sustainabilityPoints = [
  "Locally sourced materials wherever possible",
  "Plastic-free packaging approach",
  "Eco-dyed textiles wherever applicable",
  "Handmade production in thoughtful batches",
  "Longer-lasting products over disposable accessories",
  "Reduced dependence on mass-produced accessories",
  "Cultural preservation through modern utility",
  "Ethical production relationships",
];

export const giftingUseCases = [
  "Corporate gifting",
  "Festive gifting",
  "Wedding hampers",
  "Event gifting",
  "Boutique gifting",
  "International souvenir gifting",
  "Women-led impact gifting",
  "Sustainable brand collaborations",
];

export const founderQuote =
  "I started Project Umeed because I saw women with incredible skill, but limited access. Their craft had beauty. Their work had meaning. What was missing was visibility, storytelling, and a bridge to the right markets. Project Umeed is my way of helping these women carry their identity, independence, and craft into the world.";

const assetBase = process.env.PUBLIC_URL || "";

export const productPhotography = Array.from({ length: 36 }, (_, index) => {
  const number = String(index + 1).padStart(2, "0");
  return {
    src: `${assetBase}/assets/umeed-products/gallery-${number}.jpeg`,
    alt: `Project Umeed handcrafted product photo ${index + 1}`,
  };
});

export const defaultContact = {
  whatsapp_number: "+91 00000 00000",
  instagram_handle: "@projectumeed",
  email: "hello@projectumeed.in",
};
